(function () {
    "use strict";

    const CityInputStateEnum = {
        DEFAULT: "0",
        UNKNOWN: "U",
        UNIQUE: "1",
        FOREIGN: "F",
        MULTIPLE: "+",
    };

    angular.module("app").component("addressEditor", {
        template: `<ng-form name="addressForm">
            <div class="row space-below">
                <div class="">
                    <div class="col-xs-12 col-sm-3">
                        <label for="Address_Street">{{'Person_Address' | habilTranslation}} *</label>
                    </div>
                    <div class="col-xs-8 col-sm-5">
                        <fodbz-text-required style="width:100%;"
                                             fodbz-model="vm.address.Street"
                                             fodbz-maxlength="200"
                                             fodbz-field-const="Address_Street"
                                             fodbz-init="{{'Person_Street' | habilTranslation}}">
                        </fodbz-text-required>
                        <fodbz-validation fodbz-errors="addressForm.Address_Street.$error"
                                          fodbz-role="Alert" />
                    </div>
                    <div class="col-xs-2">
                        <fodbz-text-required style="width:100%;"
                                             fodbz-model="vm.address.Number"
                                             fodbz-maxlength="30"
                                             fodbz-field-const="Address_Number"
                                             fodbz-init="{{'Person_HouseNumber' | habilTranslation}}">
                        </fodbz-text-required>
                        <fodbz-validation fodbz-errors="addressForm.Address_Number.$error"
                                          fodbz-role="Alert" />
                    </div>
                    <div class="col-xs-2">
                        <fodbz-text style="width:100%;"
                                    fodbz-model="vm.address.Postbox"
                                    fodbz-maxlength="30"
                                    fodbz-field-const="Address_Postbox"
                                    fodbz-init="{{'Person_PostBox' | habilTranslation}}">
                        </fodbz-text>
                        <fodbz-validation fodbz-errors="addressForm.Address_Postbox.$error"
                                          fodbz-role="Alert" />
                    </div>
                </div>
            </div>
            <div class="row space-below">
                <div class="">
                    <div class="hidden-xs col-sm-3">
                        <label>{{'Person_PostalInfo' | habilTranslation}} *</label>
                    </div>
                    <div class="visible-xs col-xs-12">
                        <label for="Address_CountryCode">{{'Person_Country' | habilTranslation}} *</label>
                    </div>
                    <div class="col-xs-12 col-sm-3">
                        <select class="form-control"
                                id="Address_CountryCode"
                                name="Address_CountryCode"
                                ng-model="vm.address.CodeCountry"
                                ng-options="item.Key as item.Value for item in codeCountries"
                                type="text"
                                ng-change="vm.onCountrySelected()"
                                required>
                            <option value="" class="combo-placeholder" i18n="SelectItem"></option>
                        </select>
                        <fodbz-validation fodbz-errors="addressForm.Address_CountryCode.$error"
                                          fodbz-role="Alert" />
                    </div>
                    <div class="visible-xs col-xs-12">
                        <label for="Address_PostalCode">{{'Person_PostalCode' | habilTranslation}} *</label>
                    </div>
                    <div class="col-xs-12 col-sm-3">
                        <fodbz-text-required fodbz-model="vm.address.Postal"
                                             fodbz-maxlength="50"
                                             fodbz-field-const="Address_PostalCode"
                                             fodbz-init="{{'Person_PostalCode' | habilTranslation}}">
                        </fodbz-text-required>
                        <fodbz-validation fodbz-errors="addressForm.Address_PostalCode.$error"
                                          fodbz-role="Alert" />
                    </div>
                    <div class="visible-xs col-xs-12">
                        <label for="Address_City">{{'Person_City' | habilTranslation}} *</label>
                    </div>
                    <div class="col-xs-12 col-sm-3" ng-if="vm.cityInput.state !== '${CityInputStateEnum.MULTIPLE}' && vm.cityInput.state !== '${CityInputStateEnum.UNIQUE}'">
                        <fodbz-text-required fodbz-model="vm.address.City"
                                             fodbz-maxlength="50"
                                             fodbz-field-const="Address_City"
                                             fodbz-init="{{'Person_City' | habilTranslation}}">
                        </fodbz-text-required>
                        <fodbz-validation fodbz-errors="addressForm.Address_City.$error"
                                          fodbz-role="Alert" />
                    </div>
                    <div class="col-xs-12 col-sm-3" ng-if="vm.cityInput.state === '${CityInputStateEnum.UNIQUE}'">
                        {{ vm.address.City }}
                    </div>
                    <div class="col-xs-12 col-sm-3" ng-if="vm.cityInput.state === '${CityInputStateEnum.MULTIPLE}'">
                        <select class="form-control"
                                id="Address_City"
                                name="Address_City"
                                ng-model="vm.address.City"
                                ng-options="item.Key as item.Value for item in vm.cityInput.options"
                                type="text"
                                required>
                            <option value="" class="combo-placeholder" i18n="SelectItem"></option>
                        </select>
                        <fodbz-validation fodbz-errors="addressForm.Address_City.$error"
                                          fodbz-role="Alert" />
                    </div>
                </div>
            </div>
        </ng-form>`,
        bindings: {
            address: "<",
            onChanged: "&",
        },
        controller: AddressEditorComponent,
        controllerAs: "vm",
    });

    AddressEditorComponent.$inject = [
        "$rootScope", "$scope",
    ];

    function AddressEditorComponent(
        $rootScope, $scope,
    ) {
        const vm = this;

        vm.onCountrySelected = onCountrySelected;
        vm.cityInput = {
            state: CityInputStateEnum.UNKNOWN,
            options: [],
        };
        $scope.$watch("vm.address.Postal", onPostalCodeChanged);
        $scope.codeCountries = $rootScope.codeCountries;

        vm.$onInit = updateCities;

        function onCountrySelected() {
            vm.address.City = null;
            vm.address.Postal = null;

            if (vm.address.CodeCountry !== "BE") {
                vm.cityInput.state = CityInputStateEnum.FOREIGN;
                vm.cityInput.options = [];
            }
            else {
                vm.cityInput.state = CityInputStateEnum.DEFAULT;
            }
        }

        function onPostalCodeChanged(newValue, oldValue) {
            if (newValue === oldValue) {
                return;
            }

            if (vm.cityInput.state === CityInputStateEnum.FOREIGN) {
                return;
            }

            updateCities(newValue, oldValue);
        }

        function updateCities(_newPostalCode, oldPostalCode) {
            if (!vm.address || !vm.address.Postal) {
                vm.address = vm.address || {};
                vm.address.City = null;

                vm.cityInput.state = CityInputStateEnum.DEFAULT;
                return;
            }

            if (vm.address.CodeCountry !== "BE") {
                return;
            }

            if (oldPostalCode !== vm.address.Postal) {
                vm.cityInput.options = $rootScope.codePostals
                    .filter((code) => code.Key === vm.address.Postal)
                    .map(code => ({ Key: code.Value, Value: code.Value }))
                    .sort((a, b) => a.Value.localeCompare(b.Value));

                if (vm.address.PublicId == null) {
                    vm.address.City = null;
                }
            }

            if (vm.cityInput.options.length === 0) {
                if (vm.address.PublicId == null && oldPostalCode !== vm.address.Postal) {
                    vm.address.City = null;
                }

                vm.cityInput.state = CityInputStateEnum.UNKNOWN;
            }
            else if (vm.cityInput.options.length === 1) {
                vm.address.City = vm.cityInput.options[0].Value;

                vm.cityInput.state = CityInputStateEnum.UNIQUE;
            }
            else if (vm.cityInput.options.length > 1) {
                if (vm.address.PublicId == null || (oldPostalCode && oldPostalCode !== vm.address.Postal)) {
                    vm.address.City = null;
                } else if (vm.address.City != null && vm.cityInput.options.every(city => city.Value !== vm.address.City)) {
                    vm.cityInput.options.unshift({ Key: vm.address.City, Value: vm.address.City });
                    vm.cityInput.options.sort((a, b) => a.Value.localeCompare(b.Value));
                }

                vm.cityInput.state = CityInputStateEnum.MULTIPLE;
            }
        }
    };
})();
